module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jFqtM"))).then(() => parcelRequire('d0iPb'));